import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/corporate-accounts/{id}/patrons/checkins'

interface UseGetPatronCheckinsParams {
  currentPage?: number
  pageSize?: number
  corporateAccountId?: number
  startDate: Date
  endDate: Date
  sortColumnName: string
  sortOrder: string
  licensedEstablishmentId: number
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd HH:mm:ss')

export const useGetPatronCheckins = ({
  currentPage,
  pageSize,
  corporateAccountId,
  startDate,
  endDate,
  sortColumnName,
  sortOrder,
  licensedEstablishmentId,
}: UseGetPatronCheckinsParams) =>
  useApiQuery({
    path,
    method: 'get',
    queryKey: [
      path,
      currentPage,
      pageSize,
      corporateAccountId,
      formatDate(startDate),
      formatDate(endDate),
      sortColumnName,
      sortOrder,
      licensedEstablishmentId,
    ],
    queryArgs: {
      currentPage,
      pageSize,
      id: corporateAccountId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      sortColumnName,
      sortOrder,
      singleLeId: licensedEstablishmentId,
    },
  })
